/* eslint-disable */
import gql from 'graphql-tag'

export const CREATE_ATTENDEE = gql`
  mutation createAttendee($eventId: ID!, $attendee: AttendeeInput!) {
    createAttendee(eventId: $eventId, attendee: $attendee) {
      id
    }
  }
`

export const GET_ATTENDEE = gql`
  query getAttendee($eventId: ID!, $attendeeId: ID!) {
    getEventCategories(id: $eventId) {
      id
      managed
      from
      to
      flags
      builder {
        id
      }
      extraModules {
        categoriesAndZones
        mobileApp
        workshops
      }
      eventUtils {
        id
        inviteFormStyles
      }
      categories {
        id
        name
        color
        zones
      }
      numberOfZones
      attendeeFields
    }
    getAttendee(attendeeId: $attendeeId) {
      id
      fields
      status
      zones
      barcode
      category {
        id
        color
        name
        zones
      }
      avatar
      prints {
        user {
          firstName
          lastName
        }
        createdAt
      }
    }
  }
`

export const GET_ATTENDEE_BY_UUID = gql`
  query getAttendeeByUUID($attendeeUUID: String!, $eventSlug: String!) {
    getAttendeeByUUID(attendeeUUID: $attendeeUUID, eventSlug: $eventSlug) {
      id
      fields
      status
      zones
      categoryId
      category {
        id
        name
      }
      barcode
      workshops {
        id
      }
      event {
        id
        title
        cover
        from
        applicationsOpen
        to
        slug
        attendeeFields
        translation {
          eventId
          translationsJSON
        }
        location {
          venue
          address1
          address2
          city
          postalCode
          country
          eventId
        }
        categories {
          name
          zones
          id
          eventId
        }
        workshops {
          id
          name
          to
          from
          lecturers {
            id
            fields
          }
          attendanceLimit
          attending
          unlimitedAttendance
          description
        }
        organization {
          id
          publicName
          legalName
          logo
          description
          facebookLink
          webLink
        }
        extraModules {
          categoriesAndZones
          mobileApp
          workshops
          ticketing
          floorPlan
          eventId
        }
        eventUtils {
          eventId
          inviteFormStyles
        }
      }
      category {
        id
        color
        name
        zones
      }
      avatar
    }
  }
`

export const UPDATE_ATTENDEE_BY_UUID = gql`
  mutation updateAttendeeByUUID(
    $attendeeUUID: String!
    $attendeeData: JSON!
    $selectedWorkshopsIds: [ID!]!
  ) {
    updateAttendeeByUUID(
      attendeeUUID: $attendeeUUID
      attendeeData: $attendeeData
      selectedWorkshopsIds: $selectedWorkshopsIds
    )
  }
`

export const UPDATE_ATTENDEE = gql`
  mutation updateAttendee($eventId: ID!, $attendeeId: ID!, $attendee: AttendeeInput!) {
    updateAttendee(eventId: $eventId, attendeeId: $attendeeId, attendee: $attendee) {
      id
    }
  }
`

export const DELETE_ATTENDEE = gql`
  mutation deleteAttendee($eventId: ID!, $attendeeId: ID!) {
    deleteAttendee(eventId: $eventId, attendeeId: $attendeeId)
  }
`

export const DELETE_ATTENDEES = gql`
  mutation deleteAttendees($attendeeIds: [ID!]!, $eventId: ID!) {
    deleteAttendees(attendeeIds: $attendeeIds, eventId: $eventId)
  }
`

export const APPROVE_ACCREDITATIONS = gql`
  mutation approveAttendees($attendeeIds: [ID!]!, $eventId: ID!) {
    approveAttendees(attendeeIds: $attendeeIds, eventId: $eventId)
  }
`

export const APPROVE_CURATED_INVITEES = gql`
  mutation ApproveCuratedInvitees($attendeeIds: [ID!]!, $eventId: ID!) {
    approveCuratedInvitees(attendeeIds: $attendeeIds, eventId: $eventId)
  }
`
export const DENY_ACCREDITATIONS = gql`
  mutation denyAttendees($attendeeIds: [ID!]!, $eventId: ID!) {
    denyAttendees(attendeeIds: $attendeeIds, eventId: $eventId)
  }
`

export const GET_FILTERING_OPTIONS = gql`
  query GetFilteringOptions($eventId: ID!) {
    getEventCategories(id: $eventId) {
      categories {
        id
        name
      }
    }
  }
`
export const GET_ATTENDEE_BY_BARCODE = gql`
  query getAttendeeByBarcode($barcode: ID!, $eventId: ID!) {
    getAttendeeByBarcode(barcode: $barcode, eventId: $eventId) {
      id
    }
  }
`

export const GET_ATTENDEE_WORKSHOPS = gql`
  query GetAttendeeWorkshops($attendeeId: ID!) {
    getAttendeeWorkshops(attendeeId: $attendeeId)
  }
`

export const GET_ALLOWED_ATTENDEES_BY_EVENT_ID = gql`
  query GetAllowedAttendeesByEventId($eventId: ID!) {
    getAllowedAttendeesByEventId(eventId: $eventId) {
      id
      fields
    }
  }
`
